export default "__VITE_ASSET__Cu3_Bmyk__"